<template>
  <div class="body">
    <!--  头部  -->
    <div class="head">
      <div class="language" @click="">
        <div v-if="toggle" class="chese"><img src="../../../static/ico-chinese.png"/>中文</div>
        <div v-else class="english"><img src="../../../static/ico-english.png"/>EN</div>
      </div>
      <div class="logo">
        <img alt="" src="../../../static/headlogo.png">
      </div>
      <div class="des">
        <span>北京中国国际展览中心 (新馆)</span> <span>2023年10月25-28日</span>
      </div>
    </div>

    <div class="content">
      <p class="title">
        参观预登记
      </p>
      <p class="des">
        如已注册，请移步第二十届中国国际煤炭采矿技术交流及设备展览会网站 www.chinaminexpo.com 进行登录。
      </p>


      <div class="information">
        <p class="title">
          调查问卷
        </p>

        <el-form ref="form" :model="checkedValue" :rules="rules" label-position="top">

          <el-form-item label="1、贵单位性质是：" prop="companyType">
            <el-checkbox-group v-model="checkedValue.companyType">
              <el-checkbox v-for="(items,Index) in companyType" :key="Index" :label="items.content"
                           @change="handledisabled(items)" @click="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="2、您目前的工作领域：" prop="workType">
            <el-checkbox-group v-model="checkedValue.workType">
              <el-checkbox v-for="(items,Index) in workType" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="3、您对以下哪类设备感兴趣：" prop="deviceType">
            <el-checkbox-group v-model="checkedValue.deviceType">
              <el-checkbox v-for="(items,Index) in deviceType" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="4、您参加本届展览会的目的是：" prop="Reason">
            <el-checkbox-group v-model="checkedValue.Reason">
              <el-checkbox v-for="(items,Index) in Reason" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="5、您是从何途经了解本届展会：" prop="Known">
            <el-checkbox-group v-model="checkedValue.Known">
              <el-checkbox v-for="(items,Index) in Known" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="6、您在公司采购设备过程中所起的作用：" prop="Role">
            <el-checkbox-group v-model="checkedValue.Role">
              <el-checkbox v-for="(items,Index) in Role" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="7、您比较感兴趣的现场活动是：" prop="Activity">
            <el-checkbox-group v-model="checkedValue.Activity">
              <el-checkbox v-for="(items,Index) in Activity" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="8、您是否将“中国国际采矿展”作为煤炭行业唯一需要参加的展会：" prop="Only">
            <el-checkbox-group v-model="checkedValue.Only" :max="1">
              <el-checkbox v-for="(items,Index) in Only" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="9、您参加过几次“中国国际采矿展”：" prop="Times">
            <el-checkbox-group v-model="checkedValue.Times" :max="1">
              <el-checkbox v-for="(items,Index) in Times" :key="Index" :label="items.content"
                           @change="handledisabled(items)">
                {{ items.content }}
                <el-input
                    v-if="items.content === '其他，请说明'"
                    v-model="items.value"
                    :disabled="items.disabled"
                    placeholder="请输入"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

        </el-form>

        <el-button class="previous" @click="previous">上一步</el-button>
        <el-button class="next" type="primary" @click="submit">下一步</el-button>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "wxQuestionnaire",
  created() {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 10 + 'px'; //动态的设置html的font-size恒等屏幕的1/10
  },
  data() {
    return {
      toggle: '',
      //多选框选中
      checkedValue: {
        companyType: [],
        workType: [],
        deviceType: [],
        Reason: [],
        Known: [],
        Role: [],
        Activity: [],
        Only: [],
        Times: [],
      },
      companyType: [
        {id: 0, content: "煤炭生产企业", value: "煤炭生产企业"},
        {id: 1, content: "设备生产单位", value: "设备生产单位"},
        {id: 2, content: "煤化工企业", value: "煤化工企业"},
        {id: 3, content: "设计研究单位", value: "设计研究单位"},
        {id: 4, content: "地质勘探单位", value: "地质勘探单位"},
        {id: 5, content: "矿山建设单位", value: "矿山建设单位"},
        {id: 6, content: "非煤矿山企业", value: "非煤矿山企业"},
        {id: 7, content: "电力行业", value: "电力行业"},
        {id: 8, content: "社团协会组织", value: "社团协会组织"},
        {id: 9, content: "贸易代理公司", value: "贸易代理公司"},
        {id: 10, content: "政府管理机构", value: "政府管理机构"},
        {id: 11, content: "其他，请说明", disabled: true, value: null},
      ],
      workType: [
        {id: 0, content: "企业管理人员", value: "企业管理人员"},
        {id: 1, content: "工程师", value: "工程师"},
        {id: 2, content: "安全管理", value: "安全管理"},
        {id: 3, content: "机电管理", value: "机电管理"},
        {id: 4, content: "设计研发", value: "设计研发"},
        {id: 5, content: "生产制造", value: "生产制造"},
        {id: 6, content: "维护/维修", value: "维护/维修"},
        {id: 7, content: "采购", value: "采购"},
        {id: 8, content: "市场营销/业务开发", value: "市场营销/业务开发"},
        {id: 9, content: "代理/贸易/经销商", value: "代理/贸易/经销商"},
        {id: 10, content: "仓储管理/物料管理/物流/运输", value: "仓储管理/物料管理/物流/运输"},
        {id: 11, content: "媒体宣传", value: "媒体宣传"},
        {id: 12, content: "其他，请说明", disabled: true, value: null},
      ],
      deviceType: [
        {id: 0, content: "井下开采", value: "井下开采"},
        {id: 1, content: "井下掘进", value: "井下掘进"},
        {id: 2, content: "井下运输", value: "井下运输"},
        {id: 3, content: "煤矿机电与动力", value: "煤矿机电与动力"},
        {id: 4, content: "煤矿辅助生产系统", value: "煤矿辅助生产系统"},
        {id: 5, content: "自动化控制和煤矿智能化", value: "自动化控制和煤矿智能化"},
        {id: 6, content: "煤矿加工利用", value: "煤矿加工利用"},
        {id: 7, content: "露天采矿", value: "露天采矿"},
        {id: 8, content: "矿山服务与工程", value: "矿山服务与工程"},
        {id: 9, content: "矿用物资、工具及加工制造", value: "矿用物资、工具及加工制造"},
        {id: 10, content: "其他，请说明", disabled: true, value: null},
      ],
      Reason: [
        {id: 0, content: "了解新技术", value: "了解新技术"},
        {id: 1, content: "新装备", value: "新装备"},
        {id: 2, content: "对比不同产品特点", value: "对比不同产品特点"},
        {id: 3, content: "以便采购决策", value: "以便采购决策"},
        {id: 4, content: "寻求新的相关设备供应商", value: "寻求新的相关设备供应商"},
        {id: 5, content: "购买现场产品", value: "购买现场产品"},
        {id: 6, content: "寻求相关合作单位", value: "寻求相关合作单位"},
        {id: 7, content: "其他，请说明", disabled: true, value: null},
      ],
      Known: [
        {id: 0, content: "收到邀请函", value: "收到邀请函"},
        {id: 1, content: "新闻报道", value: "新闻报道"},
        {id: 2, content: "展商邀请", value: "展商邀请"},
        {id: 3, content: "报纸广告", value: "报纸广告"},
        {id: 4, content: "互联网信息", value: "互联网信息"},
        {id: 5, content: "行业协会", value: "行业协会"},
        {id: 6, content: "微信", value: "微信"},
        {id: 7, content: "其他，请说明", disabled: true, value: null},
      ],
      Role: [
        {id: 0, content: "决策者", value: "决策者"},
        {id: 1, content: "参与决策", value: "参与决策"},
        {id: 2, content: "咨询顾问", value: "咨询顾问"},
        {id: 3, content: "无权利", value: "无权利"},
        {id: 4, content: "其他，请说明", disabled: true, value: null},
      ],
      Activity: [
        {id: 0, content: "煤机装备发展论坛", value: "煤机装备发展论坛"},
        {id: 1, content: "技术交流会", value: "技术交流会"},
        {id: 2, content: "新产品发布会", value: "新产品发布会"},
        {id: 3, content: "展台现场活动", value: "展台现场活动"},
        {id: 4, content: "直播活动", value: "直播活动"},
        {id: 5, content: "其他，请说明", disabled: true, value: null},
      ],
      Only: [
        {id: 0, content: "会", value: "会"},
        {id: 1, content: "不会", value: "不会"},
        {id: 2, content: "其他，请说明", disabled: true, value: null},
      ],
      Times: [
        {id: 0, content: "首次", value: "首次"},
        {id: 1, content: "第二次", value: "第二次"},
        {id: 1, content: "第三次", value: "第三次"},
        {id: 1, content: "多次", value: "多次"},
        {id: 2, content: "其他，请说明", disabled: true, value: null},
      ],
      rules: {
        companyType: [
          {required: true, message: '至少选择一项'}
        ],
        workType: [
          {required: true, message: '至少选择一项'}
        ],
        deviceType: [
          {required: true, message: '至少选择一项'}
        ],
        Reason: [
          {required: true, message: '至少选择一项'}
        ],
        Known: [
          {required: true, message: '至少选择一项'}
        ],
        Role: [
          {required: true, message: '至少选择一项'}
        ],
        Only: [
          {required: true, message: '至少选择一项'}
        ],
        Times: [
          {required: true, message: '至少选择一项'}
        ]
      }


    }
  },
  methods: {
    handledisabled(items) {
      console.log(items)
      if (items.hasOwnProperty) {
        items.disabled = !items.disabled
        if (items.disabled) {
          items.value = null
        }
      }
    },

    previous() {
      this.$router.push('wxRegister')
    },
    submit() {
      console.log(this.checkedValue)


      this.$refs['form'].validate((valid) => {
        if (valid) {
          alert('submit!');
          this.$router.push('wxsuccessed')
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
$ue-width: 750; /* 设计稿图的宽度 */
//rem
@function px2rem($px) {
  @return #{$px/$ue-width*10}rem;
}

.body {
  font-family: PingFangSC-Regular, PingFang SC;

  .head {
    //width: px2rem(750);
    background: #006FB8; /*编译后：  p{width:1.5625rem}*/
    padding: px2rem(30) px2rem(25) px2rem(20);

    .language {
      color: #FFFFFF;
      margin-bottom: px2rem(28);

      img {
        width: px2rem(34);
        height: px2rem(34);
      }

      .english,
      .chese {
        display: flex;
        font-size: px2rem(28);
        font-weight: 400;
        align-items: center;
        justify-content: flex-end;
      }

    }

    .logo {
      width: px2rem(700);

      img {
        //max-width: 100%;
        width: px2rem(704);
      }
    }

    .des {
      font-size: px2rem(24);
      color: rgba(255, 255, 255, 0.85);
      font-weight: 500;
      margin-left: px2rem(112);

      span {
        margin-right: px2rem(15);
      }
    }
  }

  .content {
    //background: #d7d8dd;
    padding: px2rem(36) px2rem(40) px2rem(50);

    .title {
      font-size: px2rem(36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: px2rem(19);
    }

    .des {
      font-size: px2rem(24);
      line-height: px2rem(33);
      color: #999999;
      margin-bottom: px2rem(50);
    }

    //表单
    .information {
      .title {
        font-size: px2rem(32);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        margin-bottom: 0;
      }

      .next {
        width: px2rem(440);
        font-size: px2rem(32);
        font-family: PingFangSC-Regular, PingFang SC;
      }

      .previous {
        width: px2rem(210);
        font-size: px2rem(32);
        //margin-right: px2rem(20);
        font-family: PingFangSC-Regular, PingFang SC;
      }

      ::v-deep .el-form-item {
        margin-bottom: 0;
        font-weight: 400;
      }

      ::v-deep .el-form-item__label {
        font-size: px2rem(28);
        line-height: px2rem(40);
        padding-bottom: 0;
        color: #333333;
        //margin-bottom: px2rem(10);
      }

      ::v-deep .el-form-item__content {
        line-height: px2rem(40);
        background: #F6F6F7;
        border-radius: 8px;
        padding: 0 px2rem(20);
      }

      //输入框样式
      ::v-deep .el-input {
        width: px2rem(350);
      }

      ::v-deep .el-input__inner {
        height: px2rem(72);
        line-height: px2rem(72);
        font-size: px2rem(28);
        width: px2rem(350);
        margin-left: px2rem(30);
      }

      //输入框样式结束

      //多选样式
      ::v-deep .el-checkbox {
        color: #666666;
        min-width: 50%;
        margin-right: 0;
        margin: px2rem(13) 0;
        font-weight: 400;
      }

      ::v-deep .el-checkbox__input {
        line-height: 2;
      }

      ::v-deep .el-checkbox__inner {
        width: px2rem(30);
        height: px2rem(30);
      }

      ::v-deep .el-checkbox__inner::after {
        border: px2rem(3) solid #FFF;
        border-left: 0;
        border-top: 0;
        height: px2rem(15);
        left: px2rem(9);
        position: absolute;
        top: px2rem(4);
        width: px2rem(6);
      }

      ::v-deep .el-checkbox .el-checkbox__label {
        font-size: px2rem(28);
        line-height: px2rem(40);
      }

      ::v-deep .el-checkbox:last-child {
        width: 100%;
        margin: 0 0 px2rem(20);
      }

      //多选样式结束

    }

  }
}

</style>

<style scoped>

</style>

<style>

</style>
